var map = {
	"./007-microphone-1.png": 512,
	"./010-home.png": 513,
	"./013-document-1.png": 514,
	"./014-document.png": 515,
	"./015-color-palette.png": 516,
	"./017-video-camera.png": 517,
	"./image.png": 518,
	"./label.png": 519,
	"./left.svg": 520,
	"./right.svg": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;